import { useEffect, useState } from "react";
import { Navigate } from "react-big-calendar";
import PropTypes from "prop-types";

import { Default, Mobile } from "../../../components/Devices";
import CardEventsList from "./CardEventsList";
import MobileCardEventsList from "./MobileCardEventsList";
import { filteredCourses } from "../../../helpers/event";
import { useClassFilters } from "./ClassFilterProvider";

const CalendarListView = ({
	events
}) => {
	const [listEvents, setListEvents] = useState([]);

	const { filters } = useClassFilters();

	useEffect(() => {
		const monthEvents = events;
		setListEvents(monthEvents);
	}, [events]);

	return (
		<>
			<Default>
				<CardEventsList events={filteredCourses(listEvents, filters)} />
			</Default>
			<Mobile>
				<MobileCardEventsList events={filteredCourses(listEvents, filters)} />
			</Mobile>
		</>
	);
};

CalendarListView.propTypes = {
	components: PropTypes.shape({
		filters: PropTypes.shape({}).isRequired,
		setRegisteredCourses: PropTypes.func
	}).isRequired,
	events: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

CalendarListView.navigate = (date, action, { localizer }) => {
	switch (action) {
	case Navigate.PREVIOUS:
		return localizer.add(date, -3, "day");

	case Navigate.NEXT:
		return localizer.add(date, 3, "day");

	default:
		return date;
	}
};

CalendarListView.title = () => "Course List";

export default CalendarListView;
